// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"603":"d1532130","716":"d1532130"}[chunkId] + ".chunk.css";
};